module.exports = "<div class=\"am4-login__content\">\n  <p>{{'FORGOT_RESET_TOKEN_INVALID_ERROR' | translate}}</p>\n\n  <a class=\"am4-login__submit\" ui-sref=\"app.forgot.request.form\">{{'REQUEST_A_NEW_PASSWORD_RESET' | translate}}</a>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/forgot/reset/invalid.html
// module id = 168
// module chunks = 14